import * as infiniteHits from './load_more_results';

window.ProductRequestsSearch = {
  searchObject: {},
  _currentUser: null,

  initializeSearch(indexParams, searchParams, view, sortByIndices, currentUser) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this._currentUser = currentUser;
    this._initializeSearchObject();
    this._addWidgets(view, sortByIndices);
    this.searchObject.start();
    infiniteHits.loadMoreResults();
    this.searchObject.on('render', function () {
      return $.cloudinary.responsive();
    });
  },

  _initializeSearchObject() {
    this.searchObject = SearchUtils.createInstantSearch(this.indexParams.appId, this.indexParams.key, this.indexParams.name);
  },

  _addWidgets(view, sortByIndices) {
    this.searchObject.addWidgets([
      instantsearch.widgets.configure(this.searchParams),
      Widgets.clearAllWidget(),
      Widgets.statsWidget(),
      Widgets.searchBoxWidget('Search...'),
      this._stateWidget(),
      ProductWidgets.supplierWidget('suppliers'),
      this._tagWidget(),
      Widgets.sortBySelectorWidget(sortByIndices),
      this._infiniteHitsWidget(this._currentUser)
    ]);
  },

  _stateWidget() {
    const orderdedState = ['Draft', 'Posted', 'Closed'];
    return instantsearch.widgets.refinementList({
      container: '#state',
      attribute: 'state_text',
      sortBy(a, b) { return orderdedState.indexOf(a.name) < orderdedState.indexOf(b.name) ? -1 : 1; },
      limit: 5,
      searchable: false,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item(hit) {
          return "<label class='ais-RefinementList-label'>" +
            "<input type='checkbox' class='ais-RefinementList-checkbox' value='" + hit.value + "' " + (hit.isRefined ? 'checked' : '') + ">" +
            "<span class='status-label " + hit.value.toLowerCase().replace(/ /g, "_") + "'>" + hit.value + "</span>" +
            "</input><span class='ais-RefinementList-count'>" + hit.count + "</span>" +
            "</label>";
        }
      }
    });
  },

  _tagWidget() {
    return instantsearch.widgets.refinementList({
      container: '#tags',
      attribute: 'tags',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: {
        item: Widgets.refinementListTemplate
      }
    });
  },

  _infiniteHitsWidget(currentUser) {
    return instantsearch.widgets.infiniteHits({
      container: '#product-requests-result',
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list list-view grid items borders section-shadow ',
        item: 'item'
      },
      transformItems(items) {
        items.map(function (item) {
          item.isDeveloper = currentUser.company_id == item.developer_id;
          item.submittal = _.findWhere(item.submittal_states, { supplier_id: currentUser.company_id });
          return item;
        });
        return items;
      },
      templates: {
        item: $('#product-request-template').text(),
        empty: $('#no-search-results-found-template').text()
      }
    });
  }
};